// For browsers that don't support normalization (IE<=11), ignore it
export default (value) =>
  (String(value).normalize?.('NFD') ?? String(value))
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/[^ 0-9a-z]/g, '')
    .trim();
